export class FileSize {
    bytes;
    constructor(bytes) {
        this.bytes = bytes;
    }
    static Bytes(bytes) {
        return new FileSize(bytes);
    }
    static KiB(kibibytes) {
        return new FileSize(kibibytes * 1024);
    }
    static MiB(mebibytes) {
        return new FileSize(mebibytes * 1048576);
    }
    static GiB(gibibytes) {
        return new FileSize(gibibytes * 1073741824);
    }
    get KiB() {
        return this.bytes / 1024;
    }
    get MiB() {
        return this.bytes / 1048576;
    }
    get GiB() {
        return this.bytes / 1073741824;
    }
    toString() {
        const { bytes } = this;
        if (bytes >= 1073741824) {
            return `${this.GiB.toFixed(2)} GiB`;
        }
        if (bytes >= 1048576) {
            return `${this.MiB.toFixed(2)} MiB`;
        }
        if (bytes >= 1024) {
            return `${this.KiB.toFixed(2)} KiB`;
        }
        return `${bytes} bytes`;
    }
    valueOf() {
        return this.bytes;
    }
}
